import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  CurrentReportingPeriodResponseModel,
  ListReportingPeriodsRequestModel,
  ListReportingPeriodsResponseModel,
  ReportingPeriodDetailResponseModel,
  SubmissionAttemptPayloadResponseModel,
  TriggerReportingPeriodRunRequestModel,
  TriggerReportingPeriodRunResponseModel,
} from '../../models/reporting-period.model';

import { Endpoint } from '../constants/endpoint';
import { ContextKey } from '../constants/context';
import { TransformTool } from '../tools/transform.tool';

// BO-945/944 — every call sends ApiVersion 2.0 explicitly via HttpContext (the
// EventFetchService interceptor reads ContextKey.ApiVersion, defaulting to '1.0' when
// unset — omitting this on ANY call here would silently get 501 UNSUPPORTED_API_VERSION
// back, since reporting-periods serves 2.0 only, no 1.x to fall back to).
@Injectable({
  providedIn: 'root',
})
export class ReportingPeriodFetchService {
  constructor(private httpClient: HttpClient) {}

  public list(
    query: ListReportingPeriodsRequestModel
  ): Observable<ListReportingPeriodsResponseModel> {
    return this.httpClient.get<ListReportingPeriodsResponseModel>(
      `${
        Endpoint.Reporting.Period.Common
      }${TransformTool.ConvertObjectToQueryString(query)}`,
      { context: new HttpContext().set(ContextKey.ApiVersion, '2.0') }
    );
  }

  public detail(
    periodKey: string
  ): Observable<ReportingPeriodDetailResponseModel> {
    return this.httpClient.get<ReportingPeriodDetailResponseModel>(
      Endpoint.Reporting.Period.Detail(periodKey),
      { context: new HttpContext().set(ContextKey.ApiVersion, '2.0') }
    );
  }

  public current(): Observable<CurrentReportingPeriodResponseModel> {
    return this.httpClient.get<CurrentReportingPeriodResponseModel>(
      Endpoint.Reporting.Period.Current,
      { context: new HttpContext().set(ContextKey.ApiVersion, '2.0') }
    );
  }

  // BO-992 — the payload endpoint serves 2.0 ONLY, same as every route on this
  // controller; omitting ApiVersion here gateway-defaults to 1.0 and hard-501s.
  public attemptPayload(
    periodKey: string,
    attemptNo: number
  ): Observable<SubmissionAttemptPayloadResponseModel> {
    return this.httpClient.get<SubmissionAttemptPayloadResponseModel>(
      Endpoint.Reporting.Period.Payload(periodKey, attemptNo),
      { context: new HttpContext().set(ContextKey.ApiVersion, '2.0') }
    );
  }

  public triggerRun(
    periodKey: string,
    data: TriggerReportingPeriodRunRequestModel
  ): Observable<TriggerReportingPeriodRunResponseModel> {
    return this.httpClient.post<TriggerReportingPeriodRunResponseModel>(
      Endpoint.Reporting.Period.Runs(periodKey),
      data,
      { context: new HttpContext().set(ContextKey.ApiVersion, '2.0') }
    );
  }
}
